/* eslint-disable vue/component-name-in-template-casing */
const ThumbSizes = {
  small: {
    resize: {
      width: 30,
      fit: "cover"
    }
  },
  medium: {
    resize: {
      width: 300,
      fit: "cover"
    }
  },
  large: {
    resize: {
      width: 500,
      fit: "cover"
    }
  },
  small_new: {
    resize: {
      width: 140,
      height: 63,
      fit: "contain"
    }
  },
  thumb: {
    resize: {
      width: 120,
      height: 120,
      fit: "cover"
    }
  },
  company_logo: {
    resize: {
      width: 155,
      height: 33,
      fit: "cover"
    }
  },
  medium_new:{
     resize: {
      width: 1100,
      fit: "cover"
    }
  }
};

export default ThumbSizes;
